import React, { useEffect, useState } from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { useGetTicketByIdQuery } from "../../../services/ticketService";
import DosagesList from "../../../components/DosagesList";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import { ticket_types } from "../../../constants/enums";
import { tokens } from "../../../theme";
import SuccessButton from "../../../components/SuccessButton";

const ViewTicket = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: ticket, isLoading, error } = useGetTicketByIdQuery(id);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [dosages, setDosages] = useState([]);

  useEffect(() => {
    if (ticket) {
      setDosages(ticket.dosages || []);
    }
  }, [ticket]);

  if (isLoading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;

  return (
    <Box m="20px">
      <Header title="Detalles del ticket" />

      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
      >
        {/* Ticket Name */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Nombre del Ticket
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {ticket?.name}
          </Typography>
        </Box>

        {/* Ticket Type */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Tipo
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {ticket?.type && ticket_types.find((t) => t.value === ticket.type)?.label}
          </Typography>
        </Box>

        {/* Ticket Day */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Día
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {ticket?.day}
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ my: "20px", borderColor: colors.grey[700] }} />

      {/* Dosages List Section */}
      <Typography variant="h5" fontWeight="bold" mb="16px" color={colors.grey[100]}>
      Dosificaciones
      </Typography>
      <DosagesList dosagesList={dosages} isReadOnly />
      <Box
        display="flex"
        justifyContent="end"
        gap="4px"
      >
        <SuccessButton label="Ver Tickets" onClick={() => navigate('/tickets')}/>
      </Box>
    </Box>
  );
};

export default ViewTicket;